import { eases } from "library/eases"
import { fresponsive } from "library/fullyResponsive"
import styled, { css, keyframes } from "styled-components"
import colors from "styles/colors"

export default function Blog() {
	return (
		<>
			<Group>
				<Circle />
				<Circle />
				<Circle />
			</Group>
		</>
	)
}

const circleBounce1 = keyframes`
  0%, 16.67%, 33.33%, 100% {
    transform: translateY(0);
    animation-timing-function: ${eases.back.out};
  }
  8.33% {
    transform: translateY(var(--translate));
  }
`

const circleBounce2 = keyframes`
  0%, 8.33%, 25%, 41.67%, 100% {
    transform: translateY(0);
    animation-timing-function: ${eases.back.out};
  }
  16.67% {
    transform: translateY(var(--translate));
  }
`

const circleBounce3 = keyframes`
  0%, 16.67%, 33.33%, 50%, 100% {
    transform: translateY(0);
    animation-timing-function: ${eases.back.out};
  }
  25% {
    transform: translateY(var(--translate));
  }
`

const Circle = styled.div`
	border: 1px solid ${colors.blue3};

	${fresponsive(css`
		--translate: -18px;

		border-radius: 99vw;
		display: grid;
		place-items: center;
		overflow: clip;
		width: 10px;
		height: 10px;
	`)}

	&:nth-child(1) {
		animation: ${circleBounce1} 5s infinite;
	}

	&:nth-child(2) {
		animation: ${circleBounce2} 5s infinite;
	}

	&:nth-child(3) {
		animation: ${circleBounce3} 5s infinite;
	}
`

const Group = styled.div`
	${fresponsive(css`
		width: 65px;
		height: 65px;
		display: grid;
		padding: 12.5px;
		grid-template-columns: 1fr 1fr 1fr;
		gap: 4px;
		place-items: center;
	`)}
`
